// создадим элемент с прокруткой
let div = document.createElement('div');

div.style.overflowY = 'scroll';
div.style.width = '50px';
div.style.height = '50px';

// мы должны вставить элемент в документ, иначе размеры будут равны 0
if (App.ie) {
    document.body.appendChild(div);
} else {
    document.body.append(div);
}

let scrollWidth = div.offsetWidth - div.clientWidth;

if (App.ie) {
    document.body.removeChild(div);
} else {
    div.remove();
}


const body = document.getElementsByTagName('body')[0];
body.style.cssText = `--scrollbar-width: ${scrollWidth}px`;

export default scrollWidth;



// WEBPACK FOOTER //
// ./_src/js/ScrollbarWidth.js